import About from '../components/resume/About';
import Skills from '../components/resume/Skills';
import Experience from '../components/resume/Experience';
import Education from '../components/resume/Education';
import Certificates from '../components/resume/Certificates';
import ContactInfo from '../components/resume/ContactInfo';
import Strengths from '../components/resume/Strengths';
import usePageTitle from '../hooks/usePageTitle';

import { CONTACT_INFO } from '../data/resumeData';

import("../styles/resume.scss");

function Professional() {
  usePageTitle(CONTACT_INFO.name + " - " + CONTACT_INFO.title);
  
  return (
    <div id="Resume">
        <header className="header">
          <h1>{CONTACT_INFO.name}</h1>
          <div id="JobTitle">{CONTACT_INFO.title}</div>
        </header>
        <ContactInfo />
        <main className="related">
          <About />
          <Experience />
        </main>
        <aside className="stats">
          <Strengths />
          <Skills />
          <Certificates />
          <Education />
        </aside>
    </div>
  );
}

export default Professional;
